/**
 * Shared constants for calendar day field mapping and data structure.
 *
 * FIELD_TO_COLUMN — maps frontend field names to Supabase calendar_days column names.
 * Used by useUpdateCalendarDay hook and computeNewDayData for validation.
 *
 * ALL_IP_FIELDS — the set of boolean fields that live inside the `ipData` object
 * on each calendar day. If all are false, `ipData` is removed entirely (matches RPC).
 */

export const FIELD_TO_COLUMN = {
  periodDay: 'is_period',
  periodStart: 'period_start',
  periodEnd: 'period_end',
  inseminationDay: 'insemination_day',
  note: 'note',
};

export const ALL_IP_FIELDS = ['periodDay', 'periodStart', 'periodEnd', 'inseminationDay'];
